// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { useUserAuth } from "../context/UserAuthContext";
// import { db } from '../config/fbConfig';
// import {
//   collection,
//   addDoc,
//   doc,
//   getDocs,
//   updateDoc,
//   deleteDoc,
//   Timestamp
// } from 'firebase/firestore';
// import Modal from 'react-modal';
// import Loader from "./Loader";
// import SuccessModal from './SuccessModal';

// Modal.setAppElement('#root');

// const Departments = () => {
//   const { user, userData } = useUserAuth();
//   const [loading, setLoading] = useState(false);
//   const [update, setUpdate] = useState(false);
//   const [error, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [showModal, setShowModal] = useState(false);

//   const [departments, setDepartments] = useState([]);
//   const [filteredDepartments, setFilteredDepartments] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');

//   const [newDepartment, setNewDepartment] = useState({ name: '', code: '' });
//   const [editingDepartment, setEditingDepartment] = useState(null);
//   const [currentDepartment, setCurrentDepartment] = useState(null);

//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [isFetching, setIsFetching] = useState(true);

//   const departmentsCollectionRef = collection(db, "departments");

//   useEffect(() => {
//     fetchDepartments();
//   }, []);

//   useEffect(() => {
//     const filtered = departments.filter((dept) =>
//       dept.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       dept.code.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredDepartments(filtered);
//   }, [searchTerm, departments]);

//   const fetchDepartments = async () => {
//     setIsFetching(true);
//     try {
//       const data = await getDocs(departmentsCollectionRef);
//       const deptList = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
//       setDepartments(deptList);
//     } catch (error) {
//       setError("Failed to fetch departments");
//       setShowModal(true);
//     } finally {
//       setIsFetching(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewDepartment({ ...newDepartment, [name]: value });
//   };

//   const handleAddDepartment = async () => {
//     if (!newDepartment.name.trim() || !newDepartment.code.trim()) {
//       setError("Both name and code are required");
//       setShowModal(true);
//       return;
//     }
//     setUpdate(true);
//     try {
//       await addDoc(departmentsCollectionRef, {
//         ...newDepartment,
//         createdAt: Timestamp.now()
//       });
//       setSuccessMessage("Department added successfully");
//       fetchDepartments();
//       setNewDepartment({ name: '', code: '' });
//       setIsAddModalOpen(false);
//     } catch (error) {
//       setError("Failed to add department");
//     } finally {
//       setUpdate(false);
//       setShowModal(true);
//     }
//   };

//   const handleUpdateDepartment = async () => {
//     setUpdate(true);
//     try {
//       const deptDoc = doc(db, "departments", editingDepartment.id);
//       await updateDoc(deptDoc, newDepartment);
//       setSuccessMessage("Department updated successfully");
//       fetchDepartments();
//       setEditingDepartment(null);
//       setNewDepartment({ name: '', code: '' });
//       setIsEditModalOpen(false);
//     } catch (error) {
//       setError("Failed to update department");
//     } finally {
//       setUpdate(false);
//       setShowModal(true);
//     }
//   };

//   const handleEditDepartment = (dept) => {
//     setEditingDepartment(dept);
//     setNewDepartment({ name: dept.name, code: dept.code });
//     setIsEditModalOpen(true);
//   };

//   const confirmDeleteDepartment = (dept) => {
//     setCurrentDepartment(dept);
//     setIsDeleteModalOpen(true);
//   };

//   const handleDeleteDepartment = async (id) => {
//     setUpdate(true);
//     try {
//       const deptDoc = doc(db, "departments", id);
//       await deleteDoc(deptDoc);
//       setSuccessMessage("Department deleted successfully");
//       fetchDepartments();
//     } catch (error) {
//       setError("Failed to delete department");
//     } finally {
//       setUpdate(false);
//       setIsDeleteModalOpen(false);
//       setShowModal(true);
//     }
//   };

//   if (loading) return <Loader text={"LOADING"} />;
//   if (!userData) return <Loader text={"READING"} />;

//   const allowedRoles = ['Admin', 'Supreme'];

//   return (
//     <>
//       {update && <Loader text={"PROCESSING"} />}

//       {allowedRoles.includes(userData.status) ? (
//         <>
//           <div className="top-elements row align-center space-between">
//             <Link to="/home" className="back-link">
//               <i className="fa-solid fa-arrow-left size3"></i>
//             </Link>
//             <h2 className="manage-page-heading caps size4 margin-top-cashflow1">Manage Departments</h2>
//             <Link to="#" className="home-link" onClick={() => fetchDepartments()}>
//               <i className="fa-solid fa-rotate-right size4"></i>
//             </Link>
//           </div>

//           <div className="login-page-items login-page-items-cashflow column align-center scroll-fixed scroll-fixed6">
//             <button className="login-button login-button-d caps" onClick={() => setIsAddModalOpen(true)}>
//               Add Department
//             </button>

//             <input
//               type="text"
//               className="input-field1"
//               placeholder="Search by name or code"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />

//             <div className="scroll-fixed scroll-fixed1">
//               <div className="class-list class-list-d scrollable">
//                 {isFetching ? (
//                   <p className="loading-text">Loading departments...</p>
//                 ) : filteredDepartments.length === 0 ? (
//                   <p className="loading-text">No departments found.</p>
//                 ) : (
//                   filteredDepartments.map((dept) => (
//                     <div key={dept.id} className="class-item">
//                       <div className="column">
//                         <p>{dept.name} ({dept.code})</p>
//                       </div>
//                       <div className="row align-center justify-center gap-15">
//                         <button className="list-btn" onClick={() => handleEditDepartment(dept)}>
//                           <i className="fas fa-edit"></i>
//                         </button>
//                         <button className="list-btn delete-btn" onClick={() => confirmDeleteDepartment(dept)}>
//                           <i className="fas fa-trash-alt"></i>
//                         </button>
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           </div>
//         </>
//       ) : (
//         <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>
//       )}

//       {showModal && (
//         <SuccessModal
//           icon={error ? "xmark" : "check"}
//           iconColor={error ? "red" : "green"}
//           message={error || successMessage}
//           onClose={() => {
//             setError("");
//             setSuccessMessage("");
//             setShowModal(false);
//           }}
//         />
//       )}

//       {/* Add Department Modal */}
//       <Modal
//         isOpen={isAddModalOpen}
//         onRequestClose={() => setIsAddModalOpen(false)}
//         contentLabel="Add Department"
//         className="custom-modal"
//         overlayClassName="custom-modal-overlay"
//       >
//         <h2>Add Department</h2>
//         <form className="session-form">
//           <label className="input-label">Name</label>
//           <input
//             type="text"
//             name="name"
//             className="input-field"
//             placeholder="Name (e.g. IT, Accounting)"
//             value={newDepartment.name}
//             onChange={handleInputChange}
//           />
//           <label className="input-label">Code</label>
//           <input
//             type="text"
//             name="code"
//             className="input-field"
//             placeholder="Code (e.g. ITD)"
//             value={newDepartment.code}
//             onChange={handleInputChange}
//           />
//           <div className="row align-center gap-1">
//             <button className="login-button" type="button" onClick={() => setIsAddModalOpen(false)}>Cancel</button>
//             <button className="login-button" type="button" onClick={handleAddDepartment}>Add Department</button>
//           </div>
//         </form>
//       </Modal>

//       {/* Edit Department Modal */}
//       <Modal
//         isOpen={isEditModalOpen}
//         onRequestClose={() => {
//           setIsEditModalOpen(false);
//           setNewDepartment({ name: '', code: '' });
//           setEditingDepartment(null);
//         }}
//         contentLabel="Edit Department"
//         className="custom-modal"
//         overlayClassName="custom-modal-overlay"
//       >
//         <h2>Edit Department</h2>
//         <form className="session-form">
//           <label className="input-label">Name</label>
//           <input
//             type="text"
//             name="name"
//             className="input-field"
//             placeholder="Name"
//             value={newDepartment.name}
//             onChange={handleInputChange}
//           />
//           <label className="input-label">Code</label>
//           <input
//             type="text"
//             name="code"
//             className="input-field"
//             placeholder="Code"
//             value={newDepartment.code}
//             onChange={handleInputChange}
//           />
//           <div className="row align-center justify-center gap-1">
//             <button className="login-button" type="button" onClick={() => {
//               setIsEditModalOpen(false);
//               setNewDepartment({ name: '', code: '' });
//               setEditingDepartment(null);
//             }}>Cancel</button>
//             <button className="login-button" type="button" onClick={handleUpdateDepartment}>Update</button>
//           </div>
//         </form>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal
//         isOpen={isDeleteModalOpen}
//         onRequestClose={() => setIsDeleteModalOpen(false)}
//         contentLabel="Delete Department"
//         className="custom-modal"
//         overlayClassName="custom-modal-overlay"
//       >
//         <h2>Delete Department</h2>
//         {currentDepartment && (
//           <div>
//             <p>Are you sure you want to delete <strong>{currentDepartment.name}</strong> ({currentDepartment.code})?</p>
//             <div className="row align-center gap-1">
//               <button className="login-button" type="button" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
//               <button className="login-button delete-btn" type="button" onClick={() => handleDeleteDepartment(currentDepartment.id)}>
//                 Delete
//               </button>
//             </div>
//           </div>
//         )}
//       </Modal>
//     </>
//   );
// };

// export default Departments;







import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import { db } from '../config/fbConfig';
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  onSnapshot,
  Timestamp
} from 'firebase/firestore';
import Modal from 'react-modal';
import Loader from "./Loader";
import SuccessModal from './SuccessModal';

Modal.setAppElement('#root');

const Departments = () => {
  const { user, userData } = useUserAuth();
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [departments, setDepartments] = useState([]);
  const [filteredDepartments, setFilteredDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [newDepartment, setNewDepartment] = useState({ name: '', code: '' });
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [currentDepartment, setCurrentDepartment] = useState(null);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isFetching, setIsFetching] = useState(true);

  const departmentsCollectionRef = collection(db, "departments");

  // ==================== REAL-TIME LISTENER ====================
  useEffect(() => {
    if (!user?.uid) return;

    setIsFetching(true);

    const q = query(departmentsCollectionRef);

    const unsubscribe = onSnapshot(q,
      (snapshot) => {
        const deptList = snapshot.docs.map((doc) => ({ 
          ...doc.data(), 
          id: doc.id 
        }));
        setDepartments(deptList);
        setIsFetching(false);
      },
      (err) => {
        console.error("Error in departments listener:", err);
        setError("Failed to load departments");
        setShowModal(true);
        setIsFetching(false);
      }
    );

    return () => unsubscribe();
  }, [user?.uid]);

  // Search filter
  useEffect(() => {
    const filtered = departments.filter((dept) =>
      dept.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (dept.code && dept.code.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    setFilteredDepartments(filtered);
  }, [searchTerm, departments]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewDepartment({ ...newDepartment, [name]: value });
  };

  const handleAddDepartment = async () => {
    if (!newDepartment.name.trim() || !newDepartment.code.trim()) {
      setError("Both name and code are required");
      setShowModal(true);
      return;
    }
    setUpdate(true);
    try {
      await addDoc(departmentsCollectionRef, {
        ...newDepartment,
        createdAt: Timestamp.now()
      });

      setSuccessMessage("Department added successfully");
      setNewDepartment({ name: '', code: '' });
      setIsAddModalOpen(false);
    } catch (error) {
      setError("Failed to add department");
    } finally {
      setUpdate(false);
      setShowModal(true);
    }
  };

  const handleUpdateDepartment = async () => {
    setUpdate(true);
    try {
      const deptDoc = doc(db, "departments", editingDepartment.id);
      await updateDoc(deptDoc, newDepartment);

      setSuccessMessage("Department updated successfully");
      setEditingDepartment(null);
      setNewDepartment({ name: '', code: '' });
      setIsEditModalOpen(false);
    } catch (error) {
      setError("Failed to update department");
    } finally {
      setUpdate(false);
      setShowModal(true);
    }
  };

  const handleEditDepartment = (dept) => {
    setEditingDepartment(dept);
    setNewDepartment({ name: dept.name, code: dept.code });
    setIsEditModalOpen(true);
  };

  const confirmDeleteDepartment = (dept) => {
    setCurrentDepartment(dept);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteDepartment = async (id) => {
    setUpdate(true);
    try {
      const deptDoc = doc(db, "departments", id);
      await deleteDoc(deptDoc);

      setSuccessMessage("Department deleted successfully");
    } catch (error) {
      setError("Failed to delete department");
    } finally {
      setUpdate(false);
      setIsDeleteModalOpen(false);
      setShowModal(true);
    }
  };

  if (loading) return <Loader text={"LOADING"} />;
  if (!userData) return <Loader text={"READING"} />;

  const allowedRoles = ['Admin', 'Supreme'];

  const displayContent = () => {
    if (isFetching) {
      return <p className="loading-text">Loading departments...</p>;
    }

    if (filteredDepartments.length === 0) {
      return searchTerm 
        ? <p className="loading-text">No departments match your search.</p>
        : <p className="loading-text">No departments found. Add your first department.</p>;
    }

    return filteredDepartments.map((dept) => (
      <div key={dept.id} className="class-item">
        <div className="column">
          <p>{dept.name} ({dept.code})</p>
        </div>
        <div className="row align-center justify-center gap-15">
          <button className="list-btn" onClick={() => handleEditDepartment(dept)}>
            <i className="fas fa-edit"></i>
          </button>
          <button className="list-btn delete-btn" onClick={() => confirmDeleteDepartment(dept)}>
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>
    ));
  };

  return (
    <>
      {update && <Loader text={"PROCESSING"} />}

      {allowedRoles.includes(userData.status) ? (
        <>
          <div className="top-elements row align-center space-between">
            <Link to="/home" className="back-link">
              <i className="fa-solid fa-arrow-left size3"></i>
            </Link>
            <h2 className="manage-page-heading caps size4 margin-top-cashflow1">Manage Departments</h2>
            <Link 
              to="#" 
              className="home-link" 
              onClick={() => alert("Data updates automatically in real-time!")}
            >
              <i className="fa-solid fa-rotate-right size4"></i>
            </Link>
          </div>

          <div className="login-page-items login-page-items-cashflow column align-center scroll-fixed scroll-fixed6">
            <button className="login-button login-button-d caps" onClick={() => setIsAddModalOpen(true)}>
              Add Department
            </button>

            <input
              type="text"
              className="input-field1"
              placeholder="Search by name or code"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <div className="scroll-fixed scroll-fixed1">
              <div className="class-list class-list-d scrollable">
                {displayContent()}
              </div>
            </div>
          </div>
        </>
      ) : (
        <p className="male-female-stat align-center justify-center">You don't have permission to view this page.</p>
      )}

      {showModal && (
        <SuccessModal
          icon={error ? "xmark" : "check"}
          iconColor={error ? "red" : "green"}
          message={error || successMessage}
          onClose={() => {
            setError("");
            setSuccessMessage("");
            setShowModal(false);
          }}
        />
      )}

      {/* Add Department Modal */}
      <Modal
        isOpen={isAddModalOpen}
        onRequestClose={() => setIsAddModalOpen(false)}
        contentLabel="Add Department"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Add Department</h2>
        <form className="session-form">
          <label className="input-label">Name</label>
          <input
            type="text"
            name="name"
            className="input-field"
            placeholder="Name (e.g. IT, Accounting)"
            value={newDepartment.name}
            onChange={handleInputChange}
          />
          <label className="input-label">Code</label>
          <input
            type="text"
            name="code"
            className="input-field"
            placeholder="Code (e.g. ITD)"
            value={newDepartment.code}
            onChange={handleInputChange}
          />
          <div className="row align-center gap-1">
            <button className="login-button" type="button" onClick={() => setIsAddModalOpen(false)}>Cancel</button>
            <button className="login-button" type="button" onClick={handleAddDepartment}>Add Department</button>
          </div>
        </form>
      </Modal>

      {/* Edit Department Modal */}
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={() => {
          setIsEditModalOpen(false);
          setNewDepartment({ name: '', code: '' });
          setEditingDepartment(null);
        }}
        contentLabel="Edit Department"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Edit Department</h2>
        <form className="session-form">
          <label className="input-label">Name</label>
          <input
            type="text"
            name="name"
            className="input-field"
            placeholder="Name"
            value={newDepartment.name}
            onChange={handleInputChange}
          />
          <label className="input-label">Code</label>
          <input
            type="text"
            name="code"
            className="input-field"
            placeholder="Code"
            value={newDepartment.code}
            onChange={handleInputChange}
          />
          <div className="row align-center justify-center gap-1">
            <button className="login-button" type="button" onClick={() => {
              setIsEditModalOpen(false);
              setNewDepartment({ name: '', code: '' });
              setEditingDepartment(null);
            }}>Cancel</button>
            <button className="login-button" type="button" onClick={handleUpdateDepartment}>Update</button>
          </div>
        </form>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => setIsDeleteModalOpen(false)}
        contentLabel="Delete Department"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
      >
        <h2>Delete Department</h2>
        {currentDepartment && (
          <div>
            <p>Are you sure you want to delete <strong>{currentDepartment.name}</strong> ({currentDepartment.code})?</p>
            <div className="row align-center gap-1">
              <button className="login-button" type="button" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
              <button className="login-button delete-btn" type="button" onClick={() => handleDeleteDepartment(currentDepartment.id)}>
                Delete
              </button>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Departments;